import FAQStore from 'stores/common/FAQStore';
import PartnersStore from 'stores/common/PartnersStore';
import StoreContainer from 'utils/di/StoreContainer';
import BlogSubscribeFormStore from './BlogSubscribeFormStore';
import NewContactUsFormStore from './NewContactUsFormStore';
import ScheduleFormStore from './ScheduleFormStore';
import ScanElectricityBillFormStore from './ScanElectricityBillFormStore';

class CommonStoreContainer extends StoreContainer {
  get newContactUsFormStore(): NewContactUsFormStore {
    return this.getInstance('newContactUsFormStore', () => new NewContactUsFormStore());
  }

  get scheduleFormStore(): ScheduleFormStore {
    return this.getInstance('scheduleFormStore', () => new ScheduleFormStore());
  }

  get faqStore(): FAQStore {
    const { cmsService } = this.services;
    return this.getInstance('faqStore', () => new FAQStore(cmsService));
  }

  get partnersStore(): PartnersStore {
    const { cmsService } = this.services;
    return this.getInstance('partnersStore', () => new PartnersStore(cmsService));
  }

  get blogSubscribeStore(): BlogSubscribeFormStore {
    return this.getInstance('blogSubscribeStore', () => new BlogSubscribeFormStore());
  }

  get scanElectricityBillFormStore(): ScanElectricityBillFormStore {
    return this.getInstance(
      'scanElectricityBillFormStore',
      () => new ScanElectricityBillFormStore()
    );
  }
}

export default CommonStoreContainer;
